import React, { useState } from "react";
import axiosInstance, { handleApiError } from "../../services/axiosService";
import ButtonActionIcon from "../../components/BuilderComponents/ButtonActionIcon";
import Input from "../../components/FormComponents/Input";
import Textarea from "../../components/FormComponents/Textarea";
import Button from "../../components/FormComponents/Button";
import { toastError, toastSuccess } from "../../utils/toastUtils";

const AddApplicationModal = ({ editData, addApplication, editApplication }) => {
  const [applicationData, setApplicationData] = useState(editData);
  const [isLoading, setIsLoading] = useState(false);
  const [logoFile, setLogoFile] = useState(null); // to track file if user selects a new one

  const uploadLogo = async () => {
    if (!logoFile) return null;
    const formData = new FormData();
    formData.append("myFile", logoFile);
    try {
      const response = await axiosInstance.post(`/public/upload`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Zino-App-Id": editData.id || ""
        }
      });
      toastSuccess(response.message);
      return response.data.name;
    } catch (error) {
      handleApiError(error);
      return null;
    }
  };

  const handleSave = async () => {
    setIsLoading(true);

    try {
      let updatedLogo = applicationData.logo;

      if (logoFile) {
        const uploadedLogoName = await uploadLogo();
        if (uploadedLogoName) {
          updatedLogo = uploadedLogoName;
        } else {
          toastError("Error uploading logo. Please try again later.");
          return;
        }
      }

      const finalPayload = {
        ...applicationData,
        logo: updatedLogo
      };

      if (editData.id !== undefined) {
        await editApplication(finalPayload);
      } else {
        await addApplication(finalPayload);
      }
    } catch (error) {
      handleApiError(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteLogo = () => {
    setApplicationData((prev) => ({ ...prev, logo: "" }));
    setLogoFile(null);
  };

  return (
    <div className="builder_form">
      <Input
        label="Name"
        type="text"
        placeholder="Enter Application Name"
        name="name"
        value={applicationData.name}
        onChange={(e) =>
          setApplicationData({
            ...applicationData,
            [e.target.name]: e.target.value
          })
        }
      />
      <Textarea
        label="description"
        placeholder="Enter Description"
        name="description"
        value={applicationData.description}
        onChange={(e) =>
          setApplicationData({
            ...applicationData,
            [e.target.name]: e.target.value
          })
        }
      />

      {applicationData.id !== undefined && (
        <>
          <label className="builder_label">Add Logo {applicationData.logo && ` (${applicationData.logo})`}</label>
          <div className="d_flex g_8">
            <Input
              type="file"
              accept="image/*"
              onClick={(e) => e.stopPropagation()}
              onChange={(e) => setLogoFile(e.target.files[0])}
            />
            {applicationData.logo && <ButtonActionIcon type="delete" title="delete logo" onClick={handleDeleteLogo} />}
          </div>
        </>
      )}

      <Button onClick={handleSave} isLoading={isLoading}>
        {editData.id !== undefined ? "+ Edit Application" : "+ Add Application"}
      </Button>
    </div>
  );
};

export default AddApplicationModal;
